import React from "react";
import { GetCompliantFooter } from "./ProgressFooter";
import { GetCompliantPageWrapper } from "../../components/layout/GetCompliantPageWrapper";
import { Routes } from "../../root/routes";
import { SurveyAnswersReview } from "../../components/surveys/SurveyAnswersReview";

export function SurveyAnswersReviewPage() {
  return (
    <SurveyAnswersReview
      render={(isSurveyComplete, pageBody) => {
        return (
          <GetCompliantPageWrapper
            progressFooter={
              <GetCompliantFooter
                presentStep="BusinessSurvey.BusinessSurvey"
                nextLabel="Done Reviewing"
                nextDisabled={!isSurveyComplete}
                prevLabel={null}
              />
            }
          >
            {pageBody}
          </GetCompliantPageWrapper>
        );
      }}
      redirectRouteIfSurveyIncomplete={Routes.getCompliant.businessSurveyAquilo}
    />
  );
}
